import { VuexModule, Module, getModule, Mutation } from 'vuex-module-decorators';
import { UserInfoModal } from './user-info-types'
import store from '@/store/index';

@Module({
  namespaced: true,
  name: 'user-info',
  dynamic: true,
  store
})

class UserInfoStore extends VuexModule {
  data: UserInfoModal = new UserInfoModal()

  get appOrigin() {
    return this.data.appOrigin;
  }

  get isRHProtegido() {
    return this.data.isRHProtegido;
  }

  @Mutation
  setAppOrigin(payload: string) {
    this.data.appOrigin = payload;
  }

  @Mutation
  setIsRHProtegido(payload: boolean) {
    this.data.isRHProtegido = payload;
  }

  @Mutation
  resetModule() {
    this.data.appOrigin = '';
    this.data.isRHProtegido = false;
  }
}

export default getModule(UserInfoStore);
